/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

 

import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import Draggable from "react-draggable";
import { RxDot, RxDragHandleDots2 } from "react-icons/rx";
import {
  createMutationObserver,
  handleClickAway,
  parseTemplateData,
  resizeText,
  toPx,
} from "./utils";
import { nanoid } from "nanoid";
import "./TextBox.css";
import Tooltip from "./Tooltip";
import ClickAway from "./ClickAway";
import { tracker } from "./tracker";
import store from "./store";

let width = 260;

function editablePermission(e) {
  const permission = store.get("userData")?.permission;
  if (permission && permission?.permission_name !== "translator") {
    return;
  }
  e.preventDefault();
}

function TextBoxMemo(props) {
  const inputRef = useRef(null);
  const parentRef = useRef(null);
  const toolbarRef = useRef(null);
  const key = props.id ?? nanoid(5);
  const sheetId = `sheet-id--${props.pageId}`;

  
  const { readOnly, content } = props;
  const {
    position: initialPos,
    insert: insertNew,
    focused: initialFocused,
    style = {},
  } = content;
  const [focused,setFocused]=useState(!readOnly && (initialFocused ?? false));

  const readOnlyRef = useRef(readOnly); // Use a ref to hold the current value of readOnly

 

  useEffect(() => {

    readOnlyRef.current = readOnly; // Update the ref whenever readOnly changes

    if(readOnly){

      setFocused(false);

 

    }

  }, [readOnly]);

  const param = {
    key,
    id: `tbody-id--${key}`,
    ref: inputRef,
    className: `tbody cancel`,
    contentEditable: focused,
    spellCheck: "true",
    ["data-placeholder"]: "Start typing here ...",
    dangerouslySetInnerHTML: { __html: parseTemplateData(props.content.data) },
    style: {
      fontSize: props?.content?.fontSize ? props?.content?.fontSize + 1 : "",
    },
    onContextMenu: (e) => {
      if (focused) {
        // console.log(e);
      }
    },
    // onKeyDown: editablePermission,
  };

  const handleDown = (e) => {
    e.preventDefault();
    updatePos(e);
    window.pdfWin.addEventListener("mouseup", handleUp);
    window.pdfWin.addEventListener("mousemove", handleMove);
  };

  const handleMove = (e) => {
    e.preventDefault();
    const box = window.pdfDoc.getElementById(`tbox-id--${key}`);
    const diff = e.clientX - initialPos.x;

    if (width + diff < 62) {
      return;
    }

    box.style.width = `${width + diff}px`;
    width += diff;
    updatePos(e);
  };

  const handleUp = (e) => {
    removeEvent();
  };

  const updatePos = (e) => {
    initialPos.x = e.clientX;
    initialPos.y = e.clientY;
  };

  const removeEvent = () => {
    window?.pdfWin?.removeEventListener?.("mouseup", handleUp);
    window?.pdfWin?.removeEventListener?.("mousemove", handleMove);
  };
  useEffect(() => {
    return removeEvent();
  }, []);

  const getTextBoxPosition = (x = 0, y = 0) => {
    let pos = {
      x: props.content.position.x - 12,
      y: props.content.position.y - 39,
    };

    let offsetY = pos.y > 92 ? pos.top - 39 : pos.bottom + 4;
    let offsetX = 0;
    try {
      pos = window.pdfDoc
        .getElementById(`tbox-id--${key}`)
        .getBoundingClientRect();

      offsetY = pos.y > 92 ? pos.top - 39 : pos.bottom + 4;

      const sheet = window.pdfDoc
        .getElementById(sheetId)
        .getBoundingClientRect();

      return `translate(${pos.left - sheet.x + x}px, ${
        y - sheet.y + offsetY
      }px)`;
    } catch (err) {
      return `translate(${pos.x + x}px, ${pos.y + y}px)`;
    }
  };

  useEffect(() => {
    if (props.strict) return;
    resizeText(inputRef.current, parentRef.current, "px", insertNew);
  }, []);

  function syncActive(value) {
    if (readOnlyRef.current)return;
    setFocused(value);
    inputRef.current.focus();
  }

  useEffect(() => {
    const target = inputRef.current;
    const config = {
      attributes: true,
      childList: true,
      subtree: false,
      characterData: true,
    };

    const sheet = window?.pdfDoc?.getElementById?.(sheetId);
    if (!sheet) return;

    const observer = createMutationObserver(target, config, (target) =>
      tracker(target, {
        docId: props.docId,
        key,
        value: { pageid: props.pageId },
        element: inputRef.current,
        pageId: props.pageId,
      })
    );

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <ClickAway onClickAway={syncActive}>
      <div id={`textbox--main-cont--${key}`}>
        <Tooltip
          id={`tooltip-id--${key}`}
          metadata={{ key, index: props.index, pageIndex: props.pageIndex }}
          toolbarRef={toolbarRef}
          focused={focused}
          inputRef={inputRef}
          getTextBoxPosition={getTextBoxPosition}
          handleClick={(idx, value) => {
            inputRef.current.style.color = value.toString();
          }}
          onDelete={props.onDelete}
        />
        <Draggable
          handle=".tbox"
          cancel={focused ? `.cancel` : `.tbox`}
          bounds=".pdf-sheet-wrap"
          defaultPosition={initialPos}
          onStart={() => (toolbarRef.current.style.display = "flex")}
          onDrag={() => (toolbarRef.current.style.display = "none")}
          onStop={() => {
            toolbarRef.current.style.display = "flex";
            toolbarRef.current.style.transform = getTextBoxPosition();
          }}
        >
          <div
            key={key}
            ref={parentRef}
            id={`tbox-id--${key}`}
            className={`tbox pdf-text ${focused ? "focused" : ""}`}
            dataheight={style.height ? style.height + 5.2 : "null"}
            style={{
              width: `calc(${`${style.width}px`} + 12px + 2.6px + 5.6px + 6.26px)`,
              fontFamily: "'Noto Sans', sans-serif",
            }}
          >
            <div className={`tmover pdf-text ${focused ? "focused" : ""}`}>
              <RxDragHandleDots2 />
            </div>
            <div
              className={`tbody-cont pdf-text ${focused ? "focused" : ""}`}
              data-focused={focused.toString()}
              style={{
                color: `rgb(${style?.color?.map?.((c) => c * 255).join(",")})`,
                fontSize: style?.size + "px",
              }}
            >
              <div {...param} />
              <div
                className={`resizer pdf-text cancel  ${
                  focused ? "focused" : ""
                }`}
                onMouseDown={handleDown}
              >
                <RxDot />
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    </ClickAway>
  );
}

const TextBox = memo(TextBoxMemo);

export default TextBox;
